const unwrap = (response) => response.data.data;

export default (http) => ({
    async orders(params) {
        return unwrap(await http.get("/api/mysfc/backflush/orders", { params }));
    },
    async get(orderId, siteId, groupingId) {
        return unwrap(
            await http.get(`/api/mysfc/backflush/orders/${orderId}`, {
                params: { siteId, groupingId }
            })
        );
    }
});
